import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "../metaPixel";

const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pageLocation = `${location.pathname}${location.search}`;
    const trackCurrentPage = () => trackMetaPageView(pageLocation);

    trackCurrentPage();
    window.addEventListener("circlegrid-cookie-consent", trackCurrentPage);

    return () => {
      window.removeEventListener(
        "circlegrid-cookie-consent",
        trackCurrentPage,
      );
    };
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;

